import { BACKEND_URL } from "./api";

// Resolves media URLs stored in the CMS to a fully-qualified URL.
// - Absolute URLs (http/https) are returned as-is.
// - Relative paths (like `/api/files/...`) are prefixed with the runtime
//   BACKEND_URL so images work in dev, preview and production without
//   hardcoding any hostname in the database.
export function resolveMedia(url) {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}
